<div class="p-3 bg-gray h-100">
  @for(item of userDetails; track $index){

  <div class="row">
    <div class="col-md-6 col-12 mt-2">
      <label for="capacity" class="fs-14 fw-normal font-white ms-2">User Login ID</label>
      <input class="form-control bg-form-control border-0 font-white w-100 font-white" type="text" [(ngModel)]="item.UserLoginID" name="capacity" placeholder="User Login ID" readonly />
    </div>
    <div class="col-md-6 col-12 mt-2">
      <label for="capacity" class="fs-14 fw-normal font-white ms-2">User Mobile</label>
      <input class="form-control bg-form-control border-0 font-white w-100 font-white" type="text" [(ngModel)]="item.UserMobile" name="capacity" placeholder="User Mobile" readonly />
    </div>
    <div class="col-md-6 col-12 mt-3">
      <app-multi-select-dropdown
        label="User Type"
        placeholder="Select User Type(s)"
        [items]="userTypeList"
        valueProperty="UserTypeID"
        displayProperty="UserType"
        [isMultiSelect]="true"
        [(model)]="item.UserTypeIDs">
      </app-multi-select-dropdown>
    </div>

    <!-- ✅ Show selected below -->
    <!-- <div class="mt-2 font-white">
      <strong>Selected User Types:</strong>
      <span *ngFor="let id of item.UserTypeIDs" class="badge bg-primary me-1">
        {{ getUserTypeName(id) }}
      </span>
    </div> -->

    <div class="d-flex justify-content-end">
      <button class="close-btn me-2 px-4 py-1" (click)="onClose()">Close</button>
      <button class="add-btn px-4 py-1" (click)="onSubmit(item)">Update</button>
    </div>
  </div>
  }
</div>
